var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTelegram2 = function SvgTelegram2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1.19em",
    height: "1em",
    viewBox: "0 0 34.511 28.943"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 18758"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon awesome-telegram-plane",
    d: "m34.413 2.634-5.208 24.561c-.393 1.733-1.418 2.165-2.874 1.348l-7.932-5.848-3.829 3.683a1.993 1.993 0 0 1-1.595.778l.57-8.082 14.707-13.29c.639-.57-.139-.886-.994-.316L9.074 16.917l-7.827-2.446c-1.7-.532-1.733-1.7.354-2.519L32.217.153c1.418-.532 2.658.316 2.2 2.481Z",
    fill: "#fec968"
  }))));
};
export default SvgTelegram2;